import React from 'react';
import { ITaxInvoice } from '@/interfaces/report';
import { ISetting } from '@/interfaces/setting';
import TemplateTaxInvoiceHeader from './components/template-tax-invoice-header';
import TemplateTaxInvoiceItem from './components/template-tax-invoice-item';
import { chunk, sumBy } from 'lodash';

interface IProps {
  date: Date;
  setting: ISetting;
  data?: ITaxInvoice[];
}

const limit = 30;

const TM23 = ({ data, setting, date }: IProps) => {
  const totalAmount = sumBy(data || [], d => d.totalAmount);
  const totalTaxAmount = sumBy(data || [], d => d.vatAmount);
  if ((data?.length || 0) > limit) {
    const chunkedMembers = chunk(data || [], limit);
    return (
      <>
        {chunkedMembers?.map((c, i) => {
          return (
            <div
              key={i}
              style={{
                maxWidth: '209mm',
                minWidth: '209mm',
                minHeight: '296mm',
                maxHeight: '296mm',
                backgroundColor: 'white',
                margin: '0px auto',
                position: 'relative',
                paddingLeft: 20,
                paddingRight: 20,
                paddingTop: 10,
                paddingBottom: 10,
                pageBreakBefore: 'always',
              }}
            >
              <TemplateTaxInvoiceHeader
                setting={setting}
                date={date}
                currentPage={i + 1}
                pageCount={chunkedMembers?.length || 1}
              />
              <TemplateTaxInvoiceItem
                items={c || []}
                currentPage={i + 1}
                limit={limit}
                lastPage={chunkedMembers?.length === i + 1}
                totalAmount={totalAmount}
                totalVatAmount={totalTaxAmount}
              />
            </div>
          );
        })}
      </>
    );
  }
  return (
    <div
      style={{
        maxWidth: '209mm',
        minWidth: '209mm',
        minHeight: '296mm',
        maxHeight: '296mm',
        backgroundColor: 'white',
        margin: '0px auto',
        position: 'relative',
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 10,
        paddingBottom: 10,
        pageBreakBefore: 'always',
      }}
    >
      <TemplateTaxInvoiceHeader
        setting={setting}
        date={date}
        currentPage={1}
        pageCount={1}
      />
      <TemplateTaxInvoiceItem
        items={data || []}
        currentPage={1}
        limit={limit}
        lastPage={true}
        totalAmount={totalAmount}
        totalVatAmount={totalTaxAmount}
      />
    </div>
  );
};

export default TM23;
